/**
 * 门店预请求ab实验
 */
export const getShopPreRequestAbTest = () => {
  const WMABTest = Mach?.requireModule?.('SLABStrategy');
  const strategy = WMABTest?.getRealTimeStrategy?.({
    sceneKey: 'sailor_c_shop_golden_preload',
    groupKey: 'sailor_c_shop_golden_preload'
  });
  return strategy?.expKey;
};
